import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { initializeApp } from 'firebase/app';
import {
  getMessaging,
  isSupported,
  getToken,
  onMessage,
} from 'firebase/messaging';
import { iosPlugin } from './plugins/iosPlugin/iosPlugin';
import Store from './Store/Store';
import { BaseInfoActions } from './Reducer/BaseInfoReducer';

const firebaseConfig = {
  apiKey: 'AIzaSyAAaLVk9HOYuCUmBmS3icXiSFFRv-ALsPc',
  authDomain: 'safeon-56eeb.firebaseapp.com',
  projectId: 'safeon-56eeb',
  storageBucket: 'safeon-56eeb.firebasestorage.app',
  messagingSenderId: '546743957112',
  appId: '1:546743957112:web:94528cd50379a238bcdf8d',
};
const app = initializeApp(firebaseConfig);
let firebaseToken = '';
let fcmReceptionPayload = null;

export async function initFcm() {
  if (Capacitor.isNativePlatform()) {
    // ✅ 네이티브 (Android / iOS)
    try {
      const permissionResult = await PushNotifications.requestPermissions(); // 푸시 알림 권한 요청
      if (permissionResult.receive === 'granted') {
        // 권한을 허용한 경우
        if (Capacitor.getPlatform() === 'android') {
          // 안드로이드인 경우
          try {
            await PushNotifications.removeAllListeners(); // 기존 등록된 이벤트 리스너 제거(중복 등록 방지)

            // 5. 포그라운드 푸시 수신(FCM 토큰 발급과 관계없이 항상 등록해야 하는 리스너)(현재 환경에선 사용 불가)
            // data-only 메시지를 보냈는데도 pushNotificationReceived가 안 들어오는 건, Capacitor의 PushNotifications 플러그인이 FCM 데이터 메시지를 앱 레벨까지 전달하지 못하고 있다는 의미
            // 직접 Service를 만들어서 메시지를 수신하도록 해야 함
            // PushNotifications.addListener(
            //   'pushNotificationReceived',
            //   (notification) => {
            //     console.log('[PushDebug] Push received:', notification);
            //     alert('[PushDebug] Push received:', JSON.stringify(notification));
            //   }
            // );

            // 1. 권한 확인
            const permStatus = await PushNotifications.checkPermissions();
            if (permStatus.receive !== 'granted') {
              await PushNotifications.requestPermissions();
            }

            // 3. 등록 (토큰 발급 요청)
            await PushNotifications.register(); // fcm에 기기 등록 및 토큰 발급 요청 + registration이벤트 발생

            // registration 이벤트를 Promise로 감싸기(addListener가 비동기라 promise 필요)
            firebaseToken = await new Promise((resolve, reject) => {
              // 4. 토큰 수신
              PushNotifications.addListener('registration', (token) => {
                // registration 이벤트가 발생하면 토큰을 받아서 resolve(token.value)
                console.log('[PushDebug] FCM Token:', token.value);
                resolve(token.value);
              });

              // 5. 에러 수신
              PushNotifications.addListener('registrationError', (err) => {
                // 문제가 생기면 registrationError 이벤트 발생
                console.error('[PushDebug] FCM registration error:', err);
                reject(err);
              });

              // 5초 타임아웃(이벤트가 5초 안에 발생하지 않으면, setTimeout()으로 강제 reject)
              setTimeout(() => reject('FCM registration timeout'), 5000);
            });

            return { supported: true, granted: true, token: firebaseToken };
          } catch (err) {
            console.error('[PushDebug] FCM 등록 실패:', err);
            // firebaseToken = ''; // fallback 처리
            return { supported: true, granted: false, token: '' };
          }
        } else if (Capacitor.getPlatform() === 'ios') {
          // ios인 경우
          try {
            // FcmToken의 getFCMToken 메서드를 비동기로 호출
            const { token } = await iosPlugin.getFCMToken();

            // firebaseToken = token;
            console.log('🚀 FCM 토큰 받았어!', token);
            return { supported: true, granted: true, token };
            // 이 토큰을 후단이나 API에 넘길 수 있음
          } catch (err) {
            console.error('❌ FCM 토큰 받기에 실패!', err);
            return { supported: true, granted: false, token: '' };
          }
        }
      } else {
        console.warn('[PushDebug] Push permission not granted');
        return { supported: true, granted: false, token: '' };
      }
    } catch (err) {
      console.error('[Native FCM] error', err);
      return { supported: true, granted: false, token: '' };
    }
  } else {
    // ✅ 웹 (PWA)
    if (!(await isSupported()))
      return { supported: false, granted: false, token: '' };
    const swReg = await navigator.serviceWorker.register(
      '/firebase-messaging-sw.js'
    );
    const messaging = getMessaging(app);

    onMessage(messaging, (payload) => {
      console.log('[Web FCM] Foreground message:', payload);

      fcmReceptionPayload = payload;
      Store.dispatch(BaseInfoActions.setFcmReceptionPayload(payload));
    });

    const perm = await Notification.requestPermission();
    if (perm !== 'granted')
      return { supported: true, granted: false, token: '' };

    const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;
    const token = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: swReg,
    });

    return { supported: true, granted: true, token };
  }
}

export function getReceptionPayload() {
  return fcmReceptionPayload;
}
